import api from './axiosConfig.js'

export const authApi = {
  // Super Admin Authentication
  superAdminLogin: (credentials) =>
    api.post('/auth/superadmin/login', credentials),

  superAdminChangePassword: (data) =>
    api.post('/auth/superadmin/change-password', data),

  // Organization Authentication
  registerOrganization: (orgData) =>
    api.post('/auth/org/register', orgData, { skipSuccessToast: true }),

  orgLogin: (credentials) =>
    api.post('/auth/org/login', credentials),

  resetPassword: (email) =>
    api.post('/auth/org/forgot-password', { email }),

  changePassword: (data) =>
    api.post('/auth/org/change-password', data),

  // Employee Authentication
  employeeLogin: (credentials) =>
    api.post('/auth/employee/login', credentials),

  employeeForgotPassword: (data) =>
    api.post('/auth/employee/forgot-password', data),

  employeeChangePassword: (data, headers) =>
    api.post('/auth/employee/change-password', data, { headers }),

  // Device Authentication
  deviceLogin: (data) =>
    api.post('/devices/auth', data),

  // Logout (client-side only)
  logout: () => {
    localStorage.clear()
    sessionStorage.clear()
  },
}